/**
 * Created by koqiui on 2017-04-09.
 */
import { MsgBox, Vue } from '../../app.vues';
//
import SwbOrderGoodsAllocFormForSelect from './OrderGoodsAllocFormForSelect';

Vue.regist(SwbOrderGoodsAllocFormForSelect);
//
export function openGoodsAllocFromListSelectDlg(params, callback) {
    let title = params.title != null ? params.title : "配货单 - 选择";
    let sellerId = params.sellerId;
    let sellerType = params.sellerType;
    let multiSelect = params.multiSelect || false;
    let multiSelectDisabled = params.multiSelectDisabled || false;
    let checkedItem = params.checkedItem || null;
    let state = params.state;
    let initCheckedIds = params.initCheckedIds || [];
    let checkedIds = params.checkedIds || [];
    let orderFlag = params.orderFlag;
    let orderId = params.orderId || null;
    Vue.$showDialog({
        title: title,
        width: 1200,
        height: 800,
        showCloseBtn: true,
        template: '<div>' +
        '<swb-alloc-form-for-select :state="state" :orderFlag="orderFlag" :orderId="orderId" :sellerId = "sellerId" :sellerType = "sellerType" :multiSelect="multiSelect" :multiSelectDisabled="multiSelectDisabled" :checkedItem="checkedItem" :initCheckedIds="initCheckedIds" :checkedIds="checkedIds" ref="swb_alloc_form_for_select"></swb-alloc-form-for-select>' +
        '</div>',
        data: {
            sellerId: sellerId,
            sellerType: sellerType,
            multiSelect: multiSelect,
            multiSelectDisabled: multiSelectDisabled,
            checkedItem: checkedItem,
            initCheckedIds: initCheckedIds,
            checkedIds: checkedIds,
            state:state,
            orderFlag: orderFlag,
            orderId: orderId
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_alloc_form_for_select.getDlgResult() || {};
            if(result.type === 'info') {
                let allocForm = result.data;
                callback(allocForm);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {}
    });
}




//////////////////
// WEBPACK FOOTER
// ./src/compo/order/selectDlg.js
// module id = 1825
// module chunks = 1